export default "__VITE_ASSET__BmpHcDm1__"